<template>
  <div class="virtual-tray-search col-12" :class="cols == 'sm-12' ? '':'col-sm-7'">
    <div class="input-group border border-light mb-3">
      <input
        v-model="searchtext"
        @input="updateSearchQuery"
        @keydown.enter="submitSearch"
        type="search"
        class="form-control form-control-sm border-0"
        :placeholder="placeholderName"
      />
      <div class="input-group-prepend">
        <button
          tabindex="-1"
          type="submit"
          class="btn px-1 p-0"
          @click="submitSearch"
        >
        <span class="png-icon png-icon-icons-glyph--k-search"></span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  props:['cols','placeholderName','isDocument'],
  data() {
    return {
      searchtext: "",
      timeout: null,
    };
  },

  mounted(){
    if(this.isDocument == true){
      this.documentSearchInput(null);
    }
  },

  methods: {
    ...mapActions({
      updateSearchInput: "contentWizard/updateSearchInput",
      documentSearchInput: "contentWizard/documentSearchInput",
      getDocumentDetails : "contentWizard/getDocumentDetails",
      updateInspirationGalleryImages: "contentWizard/updateInspirationGalleryImages"
    }),
    updateSearchQuery(e) {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if(this.isDocument == true){
          this.documentSearchInput(e.target.value);
          this.getDocumentDetails();
        }else{
          this.updateSearchInput(e.target.value);
          this.updateInspirationGalleryImages();
        }
      }, 1000);
    },

    submitSearch() {
      if(this.isDocument == true){
        this.documentSearchInput(this.searchtext);
        this.getDocumentDetails();
      }else{
        this.updateSearchInput(this.searchtext);
        this.updateInspirationGalleryImages();
      }
    }
  },
};
</script>
